import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-glass-card',
  templateUrl: './glass-card.component.html',
  styleUrls: ['./glass-card.component.scss']
})
export class GlassCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
